import { isInFrame } from '../../../_shared/scripts/frameHelper';
import { VirtualPlatforms } from './virtualPlatforms';

// Nav els
const navEls: HTMLCollectionOf<Element> = document.getElementsByClassName('js-nav-item');
const leftNavContentEl: Element = document.getElementsByClassName('js-nav-content-left')[0];
const rightNavContentEl: Element = document.getElementsByClassName('js-nav-content-right')[0];
const toolsNavEl: Element = document.getElementsByClassName('js-nav-tools')[0];

// Left nav content
const themeContentEl: Element = document.getElementsByClassName('js-theme-selection')[0];
const productContentEl: Element = document.getElementsByClassName('js-product-selection')[0];
const patternContentEl: Element = document.getElementsByClassName('js-pattern-selection')[0];
const termsOfUsageContentEl: Element = document.getElementsByClassName('js-terms-content')[0];
const environmentContentEl: Element = document.getElementsByClassName('js-environment-selection')[0];

// Right nav content
const basketContentEl: Element = document.getElementsByClassName('js-basket-content')[0];
const favouriteContentEl: Element = document.getElementsByClassName('js-favourite-content')[0];
const shareContentEl: Element = document.getElementsByClassName('js-share-content')[0];
const virtualPlatformContentEl: Element = document.getElementsByClassName('js-vp-content')[0];
const toolsContentEl: Element = document.getElementsByClassName('js-tools')[0];
const closeRightNavEl: Element = document.getElementsByClassName('js-close-right-nav')[0];

if (closeRightNavEl) {
    closeRightNavEl.addEventListener('click', () => {
        NavHelper.closeRightNav();
    });
}

export class NavHelper {
    public static currentNav: string;
    public static isPatternContext: boolean = false;
    private static readonly COLLAPSABLE_SCREEN_WIDTH: number = 890;

    public static disableProductPageNavs() {
        [].slice.call(navEls).forEach((navEl: Element) => {
            const navType: string = navEl.getAttribute('data-nav');
            if (navType === NavTypes.Basket || navType === NavTypes.Favourite || navType === NavTypes.Share || navType === NavTypes.Home) {
                navEl.classList.add('hidden');
            }
        });
    }

    public static selectNavByName(name: string, isSubNavigation: boolean = false) {
        this.selectNav([].slice.call(navEls).find((nEl: Element) => nEl.getAttribute('data-nav') === name), isSubNavigation);
    };

    public static getSelectedNav = () => [].slice.call(navEls).find((nEl: Element) => nEl.classList.contains('selected'));

    public static setNavElEvents() {
        [].slice.call(navEls).forEach((el: Element) => {
            el.addEventListener('click', () => {
                this.selectNav(el);
            });
        });

        this.createFullScreenToggleEvent();
    };

    public static showCommercialCTAContent() {
        document.getElementsByClassName('js-basket-icon')[0].innerHTML = 'download';
        document.getElementsByClassName('js-commercial-cta')[0].classList.remove('hidden');
        document.getElementsByClassName('js-domestic-basket')[0].classList.add('hidden');
    }

    public static closeLeftNav() {
        leftNavContentEl.classList.add('hidden');
        [].slice.call(navEls).forEach((nEl: Element) => {
            if (nEl.parentElement.getAttribute('data-nav-side') == 'left') {
                nEl.classList.remove('selected');
            }
        });
    }

    public static closeRightNav() {
        rightNavContentEl.classList.add('hidden');
        [].slice.call(navEls).forEach((nEl: Element) => {
            if (nEl.parentElement.getAttribute('data-nav-side') == 'right') {
                nEl.classList.remove('selected');
            }
        });
    }

    public static setNavColourPalette({ logoUrl, logoHex, navBackgroundHex, navSubBackgroundRGBA, navPrimaryForegroundHex, navSecondaryForegroundHex }: { logoUrl: string, logoHex: string, navBackgroundHex: string, navSubBackgroundRGBA: string, navPrimaryForegroundHex: string, navSecondaryForegroundHex: string }) {
        const root: Element = document.documentElement;
        const homeEl: Element = document.getElementsByClassName('js-nav-list-left-home')[0];
        const imgEl: HTMLImageElement = homeEl.children[0] as HTMLImageElement;

        imgEl.src = logoUrl;
        imgEl.removeAttribute('style');
        homeEl.removeAttribute('style');

        root.setAttribute('style', `
            --logoBackgroundHex: ${logoHex};
            --navBackgroundHex: ${navBackgroundHex};
            --navSubBackgroundRGBA: rgba(${navSubBackgroundRGBA});
            --navPrimaryForegroundHex: ${navPrimaryForegroundHex};
            --navSecondaryForegroundHex: ${navSecondaryForegroundHex};
        `);
    }

    public static hideNavLogo() {
        const homeEl: Element = document.getElementsByClassName('js-nav-list-left-home')[0];
        const imgEl: HTMLImageElement = homeEl.children[0] as HTMLImageElement;

        imgEl.setAttribute('style', 'display: none');
        homeEl.setAttribute('style', 'background-color: #FFFFFF');
    }

    public static setHomeUrl(locationUrl: string) {
        const homeEl: Element = document.getElementsByClassName('js-nav-list-left-home')[0];

        if (!homeEl || !locationUrl) {
            return;
        }
        
        homeEl.addEventListener('click', () => {
            window.location.href = locationUrl;
        });
    }

    public static showToolsNav() {
        toolsNavEl.classList.remove('hidden');
    }

    private static createFullScreenToggleEvent() {
        const fullScreenNavBtn: HTMLButtonElement = document.getElementsByClassName('js-fs-btn')[0] as HTMLButtonElement;

        if (fullScreenNavBtn) {
            fullScreenNavBtn.addEventListener('click', (e: any) => {
                const htmlElement = e.target as HTMLElement;
                htmlElement.classList.toggle('active');

                if (isInFrame()) {
                    window.parent.postMessage(`FullScreen:${htmlElement.classList.contains('active')}`, '*');
                } else {
                    this.toggleFullScreen();
                }
            });
        }
    }

    private static toggleFullScreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }

    private static selectNav(navEl: Element, isSubNavigation: boolean = false) {
        if (!navEl) {
            return;
        }

        const hasDisabledClass = navEl.classList.contains('disabled');

        if (hasDisabledClass) {
            return;
        }

        const navType: string = navEl.getAttribute('data-nav');
        const isLeftNav: boolean = navEl.parentElement.getAttribute('data-nav-side') == 'left';
        const positionalNavEls: HTMLCollectionOf<Element> = navEl.parentElement.children;

        if (navType === NavTypes.Home) {
            return;
        }

        if (navEl.classList.contains('selected') && !isSubNavigation) {
            navEl.classList.remove('selected');

            if (isLeftNav) {
                leftNavContentEl.classList.add('hidden');
            } else {
                rightNavContentEl.classList.add('hidden');
            }

            const event: CustomEvent = new CustomEvent('menuclose', {
                detail: {
                    navType: navType
                },
                bubbles: true,
                cancelable: true,
            });

            document.dispatchEvent(event);
        } else {
            [].slice.call(positionalNavEls).forEach((nEl: Element) => {
                nEl.classList.remove('selected');
            });

            // Exception Rule: If the hidden pattern/terms of usage nav has been selected, show the 'Product' tab as selected.
            if (navEl.getAttribute('data-nav') === NavTypes.Pattern || navEl.getAttribute('data-nav') === NavTypes.TermsOfUsage) {
                [].slice.call(navEls).find((nEl: Element) => nEl.getAttribute('data-nav') === NavTypes.Product).classList.add('selected');
            }

            navEl.classList.add('selected');

            if (isLeftNav) {
                leftNavContentEl.classList.remove('hidden');

                if (window.innerWidth < this.COLLAPSABLE_SCREEN_WIDTH) {
                    this.closeRightNav();
                }
            } else {
                rightNavContentEl.classList.remove('hidden');
                closeRightNavEl.classList.remove('inverse');

                if (window.innerWidth < this.COLLAPSABLE_SCREEN_WIDTH) {
                    this.closeLeftNav();
                }
            }

            this.hideAllNavContent(isLeftNav);

            switch (navType) {
                case NavTypes.Theme:
                    themeContentEl.classList.remove('hidden');
                    break;

                case NavTypes.Product:
                    if (this.isPatternContext) {
                        patternContentEl.classList.remove('hidden');
                    } else {
                        productContentEl.classList.remove('hidden');
                    }
                    break;

                case NavTypes.Pattern:
                    this.isPatternContext = true;
                    patternContentEl.classList.remove('hidden');
                    break;

                case NavTypes.Environment:
                    environmentContentEl.classList.remove('hidden');
                    break;

                case NavTypes.TermsOfUsage:
                    termsOfUsageContentEl.classList.remove('hidden');
                    break;

                case NavTypes.Basket:
                    closeRightNavEl.classList.add('inverse');
                    basketContentEl.classList.remove('hidden');
                    break;

                case NavTypes.Favourite:
                    favouriteContentEl.classList.remove('hidden');
                    break;

                case NavTypes.Share:
                    shareContentEl.classList.remove('hidden');
                    break;

                case NavTypes.VirtualPlatforms:
                    virtualPlatformContentEl.classList.remove('hidden');
                    VirtualPlatforms.updateVirtualPlatformContent();
                    break;

                case NavTypes.Tools:
                    toolsContentEl.classList.remove('hidden');
                    break;
            }

            this.currentNav = navType;

            const event: CustomEvent = new CustomEvent('menuopen', {
                detail: {
                    navType: navType
                },
                bubbles: true,
                cancelable: true,
            });

            document.dispatchEvent(event);
        }
    };

    private static hideAllNavContent(isLeftNavContent: boolean) {
        if (isLeftNavContent) {
            themeContentEl.classList.add('hidden');
            productContentEl.classList.add('hidden');
            patternContentEl.classList.add('hidden');
            termsOfUsageContentEl.classList.add('hidden');
            environmentContentEl.classList.add('hidden');
        } else {
            basketContentEl.classList.add('hidden');
            favouriteContentEl.classList.add('hidden');
            shareContentEl.classList.add('hidden');
            virtualPlatformContentEl.classList.add('hidden');
            toolsContentEl.classList.add('hidden');
        }
    }
}

export enum NavTypes {
    Home = 'home',
    Theme = 'theme',
    Product = 'product',
    Pattern = 'pattern',
    Environment = 'environment',
    TermsOfUsage = 'termsofusage',
    Basket = 'basket',
    Favourite = 'favourite',
    Share = 'share',
    VirtualPlatforms = 'virtualplatforms',
    FullScreen = 'fullScreen',
    Tools = 'tools'
}